import type {
  AddressIdentifier,
  IncomeIdentifier,
} from '~/pages/IncomeCalculator/types';
import { commonKeys } from '~/pages/IncomeCalculator/utils';

export const keys = {
  all: [...commonKeys.all, 'calculationHistory'],
  forEmployer: (incomeIdentifier: IncomeIdentifier) => [
    ...keys.all,
    ...commonKeys.withIdentifier(incomeIdentifier),
  ],
  forProperty: (addressIdentifier: AddressIdentifier) => [
    ...keys.all,
    ...commonKeys.withIdentifier(addressIdentifier),
  ],
};
